export type ParticipantHistoryEvent = {
  user: string;
  eventType: string;
  data: Array<{
    admin: string;
    createdAt: string;
    eventType: string;
    role: string;
    participant: {
      id: string;
      avatar?: string;
      firstName: string;
      lastName: string;
    };
  }>;
};

// These are font colors for text of removed users
// MUI theme does not support multiple text colors, just primary, secondary and disabled
// This is an edge case and thus was hardcoded
export const LIGHT_THEME_RED_TEXT = '#C62828';
export const DARK_THEME_RED_TEXT = '#EF9A9A';
